import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import LoginPage from "@/pages/LoginPage";
import AppShell from "@/components/layout/AppShell";
import EmployeeDashboard from "@/pages/EmployeeDashboard";
import HistoryPage from "@/pages/HistoryPage";
import LeavePage from "@/pages/LeavePage";
import OvertimePage from "@/pages/OvertimePage";
import ApprovalsPage from "@/pages/ApprovalsPage";
import ChangePasswordPage from "@/pages/ChangePasswordPage";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminUsers from "@/pages/AdminUsers";
import AdminOffices from "@/pages/AdminOffices";
import AdminUnits from "@/pages/AdminUnits";
import AdminReports from "@/pages/AdminReports";
import AdminSettings from "@/pages/AdminSettings";

function LoadingScreen() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <div className="text-center">
        <div className="label-tiny mb-3">Memuat</div>
        <div className="font-display text-3xl font-bold tracking-tight">ABSENSI-EPISI</div>
      </div>
    </div>
  );
}

function Protected({ children, adminOnly = false, adminOrUnit = false, hideForStaff = false }) {
  const { user, loading } = useAuth();
  if (loading) return <LoadingScreen />;
  if (!user) return <Navigate to="/" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  if (adminOrUnit && !["admin", "admin_unit"].includes(user.role)) return <Navigate to="/dashboard" replace />;
  if (hideForStaff && user.role === "staff") return <Navigate to="/dashboard" replace />;
  return <AppShell>{children}</AppShell>;
}

function RootRoute() {
  const { user, loading } = useAuth();
  if (loading) return <LoadingScreen />;
  if (user) return <Navigate to="/dashboard" replace />;
  return <LoginPage />;
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<RootRoute />} />
            <Route path="/dashboard" element={<Protected><EmployeeDashboard /></Protected>} />
            <Route path="/riwayat" element={<Protected><HistoryPage /></Protected>} />
            <Route path="/cuti" element={<Protected><LeavePage /></Protected>} />
            <Route path="/lembur" element={<Protected><OvertimePage /></Protected>} />
            <Route path="/persetujuan" element={<Protected hideForStaff><ApprovalsPage /></Protected>} />
            <Route path="/ubah-password" element={<Protected><ChangePasswordPage /></Protected>} />
            <Route path="/admin" element={<Protected adminOrUnit><AdminDashboard /></Protected>} />
            <Route path="/admin/users" element={<Protected adminOrUnit><AdminUsers /></Protected>} />
            <Route path="/admin/kantor" element={<Protected adminOnly><AdminOffices /></Protected>} />
            <Route path="/admin/unit-kerja" element={<Protected adminOnly><AdminUnits /></Protected>} />
            <Route path="/admin/laporan" element={<Protected adminOrUnit><AdminReports /></Protected>} />
            <Route path="/admin/pengaturan" element={<Protected adminOnly><AdminSettings /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-right" richColors closeButton />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
